import React from 'react'
import './SkeletonLoader.css'

export default function SkeletonCard() {
    return (
        <div className='container mb-3'>
            <div className='row'>
                <div className="col-lg-3 mt-1">
                    <div className="card-skl">
                        <div className="card-img-skl skeleton">
                        </div>
                        <div className="card-body-skl">
                            <h2 className="card-title-skl skeleton">
                            </h2>
                            <p className="card-intro-skl skeleton">
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 mt-1">
                    <div className="card-skl">
                        <div className="card-img-skl skeleton">
                        </div>
                        <div className="card-body-skl">
                            <h2 className="card-title-skl skeleton">
                            </h2>
                            <p className="card-intro-skl skeleton">
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 mt-1">
                    <div className="card-skl">
                        <div className="card-img-skl skeleton">
                        </div>
                        <div className="card-body-skl">
                            <h2 className="card-title-skl skeleton">
                            </h2>
                            <p className="card-intro-skl skeleton">
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 mt-1">
                    <div className="card-skl">
                        <div className="card-img-skl skeleton">
                        </div>
                        <div className="card-body-skl">
                            <h2 className="card-title-skl skeleton">
                            </h2>
                            <p className="card-intro-skl skeleton">
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
